// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dg9R","left":"styles_left__giJlA"};